import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  maxDashboardWidth,
  maxDynamicYieldCardWidth,
  minDynamicYieldCardHeight
} from 'const/styles'
import styled, { css } from 'styled-components'
import query from 'syf-component-library/const/mediaQueries'
import { spacing } from 'syf-component-library/defaultTheme'
import Card from 'syf-component-library/ui/atoms/Card/Card'
import CardRow from 'syf-component-library/ui/atoms/Card/CardRow'
import Link from 'syf-component-library/ui/atoms/Link/Link'
import { H5, Small } from 'syf-component-library/ui/typography'

export const UpperRowText = styled(CardRow)`
  justify-content: left;
  width: 100%;
`

export const LowerRowText = styled(CardRow)`
  justify-content: flex-end;
  width: 100%;
  gap: ${spacing.small}px;
  flex-direction: column;
  align-items: flex-end;
`

export const Image = styled.img`
  width: 58px;
  height: 58px;
  object-position: center;
  object-fit: contain;
  margin-right: ${spacing.base}px;

  @media ${query.greaterThanSmall} {
    margin-right: ${spacing.large}px;
  }
`

export const CampaignTitle = styled(H5)`
  color: ${({ theme }) => theme.lightGrey};
`

export const Subtitle = styled(Small)`
  color: ${({ theme }) => theme.lightGrey};
`

export const YieldCard = styled(Card)`
  position: relative;
  min-height: ${minDynamicYieldCardHeight}px;
  width: 100%;
  max-width: ${maxDynamicYieldCardWidth}px;
  background-color: ${({ theme }) => theme.navyBlue};
  box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.2);
  padding: ${spacing.base}px;
  @media ${query.greaterThanSmall} {
    min-height: 150px;
  }
`

export const ArrowIcon = styled(FontAwesomeIcon)`
  margin-left: ${spacing.small}px;
`

export const DynamicYieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: flex-start;
  margin-bottom: ${spacing.xlarge}px;
  gap: ${spacing.medium}px;
  padding: 0px ${spacing.base}px;
  max-width: ${maxDashboardWidth}px;
  @media ${query.greaterThanSmall} {
    gap: ${spacing.base}px;
    align-items: flex-start;
  }

  @media ${query.greaterThanHuge} {
    flex-direction: row;
    gap: ${spacing.large}px;
    align-items: stretch;
  }
`

const CampaignCTA = css`
  color: ${({ theme }) => theme.white};
  align-items: right;
  &:visited {
    color: ${({ theme }) => theme.white};
  }
`

export const CampaignLink = styled(Link)`
  ${CampaignCTA}
`
